import { HttpParams } from '@angular/common/http';

/**
 * Rack keeps only the last value of a repeated query key (`a=1&a=2` -> `"2"`),
 * which is exactly what Angular produces for array params. Rails only sees an
 * array when the key is bracketed, so arrays are serialized as `a[]=1&a[]=2`.
 */
export const toHttpParams = (params: object): HttpParams =>
  Object.entries(params).reduce(
    (httpParams, [key, value]) =>
      Array.isArray(value)
        ? value.reduce(
            (withItem, item) => withItem.append(`${key}[]`, item),
            httpParams
          )
        : httpParams.set(key, value),
    new HttpParams()
  );

/**
 * Filters were single valued before multi select, so entries already in
 * localStorage still hold plain values. Widen them instead of dropping them.
 */
export const toMultiValueFilters = <T>(filters: object): T =>
  Object.entries(filters).reduce(
    (widened, [key, value]) => ({
      ...widened,
      [key]: value == null ? [] : [].concat(value),
    }),
    {}
  ) as T;
